import packageSample1 from "./packageSample1.jpg";
import packageSample2 from "./packageSample2.jpg";
import packageSample3 from "./packageSample3.jpg";
import uploadHeadshot1 from "./uploadHeadshot1.png";
import uploadHeadshot2 from "./uploadHeadshot2.png";
import uploadHeadshot3 from "./uploadHeadshot3.png";
import uploadHeadshot4 from "./uploadHeadshot4.png";
import uploadHeadshot5 from "./uploadHeadshot5.png";
import uploadHeadshot6 from "./uploadHeadshot6.png";
import uploadHeadshot7 from "./uploadHeadshot7.png";
import uploadBody1 from "./uploadBody1.png";
import uploadBody2 from "./uploadBody2.png";
import uploadBody3 from "./uploadBody3.png";
import uploadBody4 from "./uploadBody4.png";
import uploadBody5 from "./uploadBody5.png";
import uploadBody6 from "./uploadBody6.png";
import uploadBody7 from "./uploadBody7.png";
import goodphoto1 from "./goodphoto1.png";
import goodphoto2 from "./goodphoto2.png";
import goodphoto3 from "./goodphoto3.png";
import goodphoto4 from "./goodphoto4.png";
import badphoto1 from "./badphoto1.png";
import badphoto2 from "./badphoto2.png";
import badphoto3 from "./badphoto3.png";
import badphoto4 from "./badphoto4.png";
import badphoto5 from "./badphoto5.png";
import warningphoto1 from "./warningphoto1.png";
import warningphoto2 from "./warningphoto2.png";
import warningphoto3 from "./warningphoto3.png";
import warningphoto4 from "./warningphoto4.png";
import notice from "./notice.png";

const dashboardImages = {
  packageSample1,
  packageSample2,
  packageSample3,
  uploadHeadshot1,
  uploadHeadshot2,
  uploadHeadshot3,
  uploadHeadshot4,
  uploadHeadshot5,
  uploadHeadshot6,
  uploadHeadshot7,
  uploadBody1,
  uploadBody2,
  uploadBody3,
  uploadBody4,
  uploadBody5,
  uploadBody6,
  uploadBody7,
  goodphoto1,
  goodphoto2,
  goodphoto3,
  goodphoto4,
  badphoto1,
  badphoto2,
  badphoto3,
  badphoto4,
  badphoto5,
  warningphoto1,
  warningphoto2,
  warningphoto3,
  warningphoto4,
  notice,
};

export default dashboardImages;
